import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["latestMessage"]
  static values = { url: String }

  connect() {
    // console.log(this.latestMessageTarget);
    // this.latestMessageTarget.scrollIntoView({block: 'nearest'});
  }

  showAllReplies(event) {
    const url = event.currentTarget.dataset.chatUrlValue
    const frameId = event.currentTarget.dataset.turboFrame
    const frame = document.getElementById(frameId)
    
    if (frame) {
      frame.src = url
      frame.reload()
    }
  }
}
